exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scene {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\nmat-grid-list {\r\n    margin-top: 25px;\r\n    margin-left: -1px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/generator.component.css
// module id = ../../../../../src/app/generator/generator.component.css
// module chunks = main